// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../.config/yarn/global/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-cta-default[data-v-1b61c84d]{background-color:#ffef29}.border-cta-default[data-v-1b61c84d]{border-color:#ffef29}", ""]);
// Exports
module.exports = exports;
